export function numberCommaSeparated(
  value: number,
  noValueText?: string,
): string {
  const noValue = noValueText ? noValueText : 0;
  return value > 0 ? value.toLocaleString("en-US") : `${noValue}`;
}
